import { render, staticRenderFns } from "./kpiRecord.vue?vue&type=template&id=651a37fc&"
import script from "./kpiRecord.vue?vue&type=script&lang=js&"
export * from "./kpiRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports